/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unstable-nested-components */
import React, { useRef, useState, useEffect } from 'react';
import { AvatarLargeInterface } from './avatarTypes';
import './avatar.scss';
import '../../constants/_global.scss';
import { ReactComponent as Camera } from '../../assets/camera.svg';

enum BUTTON_TEXT {
  UPLOAD = 'Добавить фото',
  EDIT = 'Изменить фото',
}

const AvatarLarge: React.FC<AvatarLargeInterface> = ({ avatar, onEdit }) => {
  const [imgUrl, setImgUrl] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (avatar && typeof avatar === 'string') {
      setImgUrl(avatar);
    }
  }, [avatar]);

  const handleUploadClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const url = URL.createObjectURL(file);
      setImgUrl(url);
      // imgUrl ? onAdd(file) : onEdit(file);
      if (onEdit) {
        onEdit(event);
      }
    } else {
      console.log('No file selected');
    }
  };

  return (
    <div className="columnLarge">
      <div className="circleLarge">
        {imgUrl ? (
          <img className="avatarPic" src={imgUrl} alt="аватар" />
        ) : (
          <Camera />
        )}
      </div>
      <input
        className="hidenInput"
        type="file"
        ref={inputRef}
        onChange={handleFileChange}
      />
      <button
        className="spanGlobal btn"
        onClick={handleUploadClick}
        type="button"
      >
        {imgUrl ? BUTTON_TEXT.EDIT : BUTTON_TEXT.UPLOAD}
      </button>
    </div>
  );
};

export default AvatarLarge;
